module.exports = __webpack_public_path__ + "static/media/nag1.dbdb5067.png";